import { useUser } from 'stores/user/useUser';

export function formatGenericNumber(num: number): string {
  const userStore = useUser();
  return Intl.NumberFormat(userStore.getPreferredLanguage).format(num);
}

export function formatMoney(
  amount: number | string | undefined,
  currency: string
): string | undefined {
  if (amount === undefined) {
    return undefined;
  }
  if (typeof amount === 'string') {
    amount = parseFloat(amount);
  }
  try {
    const userStore = useUser();
    return new Intl.NumberFormat(userStore.getPreferredLanguage, {
      style: 'currency',
      currency: currency,
    }).format(amount);
  } catch {
    return `${formatGenericNumber(amount)} ${currency}`;
  }
}

/**
  Safely parses a value into a number. If the value is not convertible to a finite number it returns a fallback value (0 by default).
*/
export function safeParseFloat(
  value: number | string,
  o?: { fallback?: number }
): number {
  const parsed = typeof value === 'number' ? value : parseFloat(value);
  return Number.isFinite(parsed) ? parsed : (o?.fallback ?? 0);
}

export function toNumber(
  value: string | null | undefined | number
): number | undefined {
  if (typeof value === 'number') {
    return value;
  }
  if (!value) {
    return undefined;
  }
  return Number(value);
}
